// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonZoomZoomPlusMinus_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.49523 8.99975C6.88941 8.99975 8.09367 8.18251 8.65488 6.99983H9.73546C9.61648 7.33674 9.45855 7.65523 9.26709 7.94989L12 11.2929 11.2935 12 7.95568 9.26676C7.24875 9.73023 6.40344 9.99975 5.49523 9.99975 3.93639 9.99975 2.56283 9.20575 1.75628 7.9998H3.04851C3.67919 8.61843 4.5429 8.99975 5.49523 8.99975ZM3.04851 2.99994C3.67919 2.38131 4.5429 2 5.49523 2 6.88941 2 8.09367 2.81723 8.65488 3.99992H9.73546C9.11825 2.25218 7.45284 1 5.49523 1 3.93639 1 2.56283 1.79399 1.75628 2.99994H3.04851ZM.999126 3.99992H1.99913V4.99989H2.99738V5.99986H1.99913V6.99991H.999126V5.99986H0V4.99989H.999126V3.99992ZM10.9904 4.99989H7.99301V5.99986H10.9904V4.99989Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.0918 3.63604C18.0743 4.61852 18.7821 5.77164 19.2153 7H17.0545C16.7201 6.29472 16.2611 5.63379 15.6776 5.05025 13.3562 2.72884 9.80992 2.37875 7.11908 4H4.01929C4.13013 3.87629 4.24499 3.75492 4.36386 3.63604 7.87858.12132 13.5771.12132 17.0918 3.63604ZM17.0545 13H19.2153C18.7821 14.2284 18.0743 15.3815 17.0918 16.364 13.5771 19.8787 7.87858 19.8787 4.36386 16.364 4.24499 16.2451 4.13013 16.1237 4.01929 16H7.11907C9.80991 17.6212 13.3562 17.2712 15.6776 14.9497 16.2611 14.3662 16.7201 13.7053 17.0545 13ZM23.4557 21.3137 19.9202 16.364 17.0918 19.1924 22.0415 22.7279 23.4557 21.3137ZM5 14H3V11H0V9H3V6H5V9H8V11H5V14ZM21 9H15V11H21V9Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonZoomZoomPlusMinus is a generated icon component.
 */
let IconCommonZoomZoomPlusMinus = IconCommonZoomZoomPlusMinus_1 = class IconCommonZoomZoomPlusMinus extends IconBaseElement {
    render() {
        return html `${IconCommonZoomZoomPlusMinus_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonZoomZoomPlusMinus.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonZoomZoomPlusMinus = IconCommonZoomZoomPlusMinus_1 = __decorate([
    customElement('zui-icon-common-zoom-zoom-plus-minus')
], IconCommonZoomZoomPlusMinus);
export { IconCommonZoomZoomPlusMinus };
